import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: {
            data: [],
            links: {},
            meta: {},
        },
        item: {},
    },
    getters: {
        items: state => state.items,
        item: state => state.item,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setItem(state, item) {
            state.item = item;
        }
    },
    actions: {
        async index({ commit, rootState }) {
            const response = await http.get('freeradius/auth', {params: rootState.route.query});

            commit('setItems', response.data);

            return response;
        }
    }
}